import type { Server, ServerGroup, VoiceParticipant } from '@/types'

export const servers: Record<string, Server> = {
  's1': {
    id: 's1', name: 'Arcus HQ', iconText: 'A', iconColor: '#3ECFCF', memberCount: 847, unreadCount: 12, mentionCount: 2, tier: 'blaze', isOwner: true,
    welcomeScreen: {
      description: 'Welcome to Arcus HQ! Please review the community rules before chatting.',
      rules: [
        'Be respectful and constructive',
        'No spam or self-promotion',
        'Keep discussions on-topic in the appropriate channels',
        'Do not share personal information of others',
        'Follow the Arcus Terms of Service',
      ],
    },
    categories: [
      { id: 'c1-info', name: 'Information', collapsed: false },
      { id: 'c1-general', name: 'General', collapsed: false },
      { id: 'c1-voice', name: 'Voice Channels', collapsed: false },
      { id: 'c1-community', name: 'Community', collapsed: false },
    ],
    channels: [
      { id: 'ch1', name: 'welcome', type: 'text', categoryId: 'c1-info', topic: 'Welcome to Arcus — privacy-first communication', unreadCount: 0, mentionCount: 0 },
      { id: 'ch2', name: 'announcements', type: 'announcement', categoryId: 'c1-info', topic: 'Official announcements', unreadCount: 3, mentionCount: 1 },
      { id: 'ch3', name: 'general', type: 'text', categoryId: 'c1-general', topic: 'General discussion', unreadCount: 7, mentionCount: 1, slowmode: 10 },
      { id: 'ch4', name: 'off-topic', type: 'text', categoryId: 'c1-general', topic: 'Anything goes', unreadCount: 2, mentionCount: 0 },
      { id: 'ch5', name: 'dev-chat', type: 'text', categoryId: 'c1-general', topic: 'Development discussion', unreadCount: 0, mentionCount: 0 },
      { id: 'ch6', name: 'Lounge', type: 'voice', categoryId: 'c1-voice', unreadCount: 0, mentionCount: 0, userLimit: 10 },
      { id: 'ch7', name: 'Gaming', type: 'voice', categoryId: 'c1-voice', unreadCount: 0, mentionCount: 0, userLimit: 5 },
      { id: 'ch17', name: 'feedback', type: 'forum', categoryId: 'c1-community', topic: 'Share feedback and feature requests', unreadCount: 4, mentionCount: 0 },
      { id: 'ch18', name: 'mature-content', type: 'text', categoryId: 'c1-community', topic: 'Age-restricted content', unreadCount: 0, mentionCount: 0, nsfw: true },
    ],
    bannerUrl: 'https://placehold.co/480x120/1A1F2E/3ECFCF?text=Arcus+HQ',
  },
  's2': {
    id: 's2', name: 'Rust Devs', iconText: 'R', iconColor: '#E8A840', memberCount: 2341, unreadCount: 5, mentionCount: 0, tier: 'forge', isOwner: false,
    categories: [
      { id: 'c2-general', name: 'General', collapsed: false },
      { id: 'c2-help', name: 'Help', collapsed: false },
    ],
    channels: [
      { id: 'ch8', name: 'general', type: 'text', categoryId: 'c2-general', topic: 'Rust programming discussion', unreadCount: 5, mentionCount: 0 },
      { id: 'ch9', name: 'showcase', type: 'text', categoryId: 'c2-general', topic: 'Show off your projects', unreadCount: 0, mentionCount: 0 },
      { id: 'ch10', name: 'beginners', type: 'text', categoryId: 'c2-help', topic: 'No question is too simple', unreadCount: 0, mentionCount: 0 },
      { id: 'ch11', name: 'async-help', type: 'text', categoryId: 'c2-help', topic: 'Async Rust support', unreadCount: 0, mentionCount: 0 },
    ],
    bannerUrl: 'https://placehold.co/480x120/1A1F2E/E8A840?text=Rust+Devs',
  },
  's3': {
    id: 's3', name: 'Privacy Collective', iconText: 'PC', iconColor: '#3ECF7B', memberCount: 512, unreadCount: 0, mentionCount: 0, tier: 'free', isOwner: true,
    categories: [{ id: 'c3-main', name: 'Main', collapsed: false }],
    channels: [
      { id: 'ch12', name: 'general', type: 'text', categoryId: 'c3-main', topic: 'Privacy tools and discussion', unreadCount: 0, mentionCount: 0 },
      { id: 'ch13', name: 'tools', type: 'text', categoryId: 'c3-main', topic: 'Privacy tool recommendations', unreadCount: 0, mentionCount: 0 },
      { id: 'ch14', name: 'news', type: 'text', categoryId: 'c3-main', topic: 'Privacy news and updates', unreadCount: 0, mentionCount: 0 },
    ],
  },
  's4': {
    id: 's4', name: 'Game Night', iconText: 'GN', iconColor: '#CF3E4F', memberCount: 89, unreadCount: 0, mentionCount: 0, tier: 'free', isOwner: true,
    categories: [
      { id: 'c4-main', name: 'Chat', collapsed: false },
      { id: 'c4-voice', name: 'Voice', collapsed: false },
    ],
    channels: [
      { id: 'ch15', name: 'planning', type: 'text', categoryId: 'c4-main', topic: 'Plan game nights here', unreadCount: 0, mentionCount: 0 },
      { id: 'ch16', name: 'Game Room', type: 'voice', categoryId: 'c4-voice', unreadCount: 0, mentionCount: 0 },
    ],
  },
}

export const serverGroups: ServerGroup[] = [
  { id: 'g1', name: 'Favorites', serverIds: ['s1'], collapsed: false },
  { id: 'g2', name: 'Communities', serverIds: ['s2', 's3', 's4'], collapsed: false },
]

export const serverOrder = ['s1', 's2', 's3', 's4']

export const voiceChannelParticipants: Record<string, VoiceParticipant[]> = {
  'ch6': [
    { userId: 'u2', isMuted: false, isDeafened: false, isSpeaking: true, isCameraOn: true, isScreenSharing: false },
    { userId: 'u7', isMuted: true, isDeafened: false, isSpeaking: false, isCameraOn: false, isScreenSharing: false },
    { userId: 'u8', isMuted: false, isDeafened: false, isSpeaking: false, isCameraOn: false, isScreenSharing: true },
  ],
  'ch7': [],
  'ch16': [{ userId: 'u3', isMuted: false, isDeafened: false, isSpeaking: false, isCameraOn: false, isScreenSharing: false }],
}
